export default __webpack_public_path__ + "static/gocardless-case-study-og-6b56f0b48e428952ee798d850d99dd71.png";